import { render, staticRenderFns } from "./AdminContributionModalFooter.vue?vue&type=template&id=3aaa07f4&"
import script from "./AdminContributionModalFooter.vue?vue&type=script&lang=js&"
export * from "./AdminContributionModalFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports